<template>
  <div class="basicInformation common_group">
    <div class="title">
      <img src="@/assets/images/informationIcon.png">
      <span>{{ $t('newApp.activityInfo.ei') }}</span>
    </div>
    <el-form class="common_form" label-position="left" ref="activityInfoForm" :rules="rules" label-width="174px"
             :model="formData"
    >
      <el-row>
        <!-- 活动名称 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.activityInfo.noa')" prop="activityName">
            <el-input v-model="formData.activityName" maxlength="200" :disabled="isReadOnly" />
          </el-form-item>
        </el-col>
        <!-- 业务单元 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="salerData.belongToQyw && unitNameList.length > 0">
          <el-form-item :label="$t('newApp.activityInfo.bu')" prop="businessUnitDisplayed"
                        :required="salerData.belongToQyw && unitNameList.length > 0"
          >
            <el-select v-model="formData.businessUnitDisplayed" multiple collapse-tags placeholder
                       :disabled="isReadOnly"
            >
              <el-option v-for="item in unitNameList" :key="item.id" :label="item.unitName" :value="item.unitName" />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 活动分类 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.activityInfo.coa')" prop="activityClassificationCode">
            <el-select v-model="formData.activityClassificationCode"
                       :disabled="isReadOnly || (isEditable !== 0 && isEditable !== 1)" :placeholder="$t('general.ps')"
                       @change="activityClassificationCodeChange"
            >
              <el-option v-for="item in activityClassificationList" :key="item.fieldKey" :label="item.fieldValue"
                         :value="item.fieldKey"
                         v-if="!($store.state.useSimplifiedForm && ['AC_01','AC_03'].includes(item.fieldKey) && formData.activityClassificationCode !== item.fieldKey)"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 模板活动 - 总部活动 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="relationActivityShow && !($store.state.useSimplifiedForm && formData.activityClassificationCode === 'AC_06')">
          <!--关联活动分类名称 -->
          <el-form-item :label="relationActivityName" prop="relatedActivityCode" :required="relationActivityRequired">
            <div style="display:flex">
              <el-select v-if="($route.path !== '/activityTransferApplication' || $route.path === '/activityTransferApplication' && editEchoData.marketActivity.reportType !== 1)" v-model="formData.relatedActivityCode" :disabled="isReadOnly && (isFilterFields('relatedActivityCode') && editEchoData.marketActivity.reportType !== 2)" placeholder
                         @change="relatedActivityChange"
              >
                <el-option v-for="item in relationActivityList" :key="item.code" :label="item.text"
                           :value="item.code"
                />
              </el-select>
              <el-input v-else disabled v-model="formData.relatedActivityName" />
              <el-button type="text" v-if="relationActivityName === $t('newApp.activityInfo.ta') && sourceLink"
                         @click="downloadCommand"
              >
                {{ $t('general.Download') }}
              </el-button>
            </div>
          </el-form-item>
        </el-col>
        <!-- 活动形式 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.activityInfo.foa')" prop="activityForms">
            <el-select v-model="formData.activityForms" :disabled="isReadOnly" :placeholder="$t('general.ps')">
              <el-option v-for="item in activityFormsList" :key="item.fieldKey" :label="item.fieldValue"
                         :value="item.fieldValue"
                         v-if="!($store.state.useSimplifiedForm && item.fieldKey === 'AF_03' && formData.activityForms !== item.fieldValue)"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 主办方 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8"
                v-if="(!salerData.belongToSmb && formData.activityClassificationCode && formData.activityClassificationCode !== 'AC_03') || formData.organizer"
        >
          <el-form-item :label="$t('newApp.activityInfo.Organizer')" prop="organizer">
            <el-select v-model="formData.organizer" @change="organizerChange" :disabled="isReadOnly"
                       :placeholder="$t('general.ps')"
            >
              <el-option v-for="item in organizerList" :key="item.fieldKey" :label="item.fieldValue"
                         :value="item.fieldValue"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 增加非中文状态显示 -->
        <!-- 拟邀请总人数 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="!inviterNum">
          <el-form-item :label="$t('newApp.activityInfo.tnoptbi')" prop="inviterNum">
            <el-input v-model="formData.inviterNum" :disabled="isReadOnly" @input="inviterNumFilter" maxlength="9" />
          </el-form-item>
        </el-col>
        <!-- 主要目标对象 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="!salerData.belongToSmb || formData.targetObject">
          <el-form-item :label="$t('newApp.activityInfo.mta')" prop="targetObject">
            <el-select v-model="formData.targetObject" @change="qdMeetingSegmentClear" :disabled="isReadOnly"
                       :placeholder="$t('general.ps')"
            >
              <el-option v-for="item in filteredTargetObjectList"
                         :key="item.fieldKey" :label="item.fieldValue"
                         :value="item.fieldValue"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 主要目标对象-其它内容 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="isTargetObjectOther">
          <el-form-item :label="$t('newApp.activityInfo.otherTargetObject')" prop="targetObjectOther" :rules="[{ required: true, message: $t('newApp.activityInfo.otherTargetObjectP'), trigger: 'blur' }]">
            <el-input v-model="formData.targetObjectOther" :placeholder="$t('newApp.activityInfo.otherTargetObjectP')" :maxlength="200" :disabled="isReadOnly" />
          </el-form-item>
        </el-col>
        <!-- 活动类型 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.activityInfo.toa')" prop="activityTypeCode">
            <el-select v-model="formData.activityTypeCode" @change="activityTypeChange" :disabled="isReadOnly && !isFilterFields('activityTypeCode')"
                       :placeholder="$t('general.ps')"
            >
              <el-option v-for="item in activityTypeList" :key="item.fieldKey" :label="item.fieldValue"
                         :value="item.fieldKey"
                         v-if="!($store.state.useSimplifiedForm && ['2-ver02','12-ver02','6-ver02','9-ver02'].includes(item.fieldKey) && formData.activityTypeCode !== item.fieldKey)"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 渠道会议细分 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8"
                v-if="formData.targetObject === `${$t('general.Channel')}` && formData.activityTypeCode === '1-ver02'"
        >
          <el-form-item :label="$t('newApp.activityInfo.cms')" prop="qdMeetingSegment">
            <el-select v-model="formData.qdMeetingSegment" :disabled="isReadOnly && !isFilterFields('qdMeetingSegment')" :placeholder="$t('general.ps')">
              <el-option v-for="item in qdMeetingSegmentList" :key="item.fieldKey" :label="item.fieldValue"
                         :value="item.fieldValue"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 新字段 -->
        <!-- 品推支持 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="brandPromotionSupportShow && !$store.state.useSimplifiedForm">
          <el-form-item :label="$t('newApp.activityInfo.ps')">
            <el-select v-model="formData.brandPromotionSupport" :disabled="isReadOnly" :placeholder="$t('general.ps')"
                       @change="brandPromotionSupportChange"
            >
              <el-option v-for="item in brandPromotionSupporList" :key="item.fieldKey" :label="item.fieldValue"
                         :value="item.fieldValue"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 举办城市 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.activityInfo.hc')" prop="city">
            <el-input v-model="formData.city" :disabled="isReadOnly" maxlength="50" />
          </el-form-item>
        </el-col>
        <!-- 转申请可以编辑预计举办日期 -->
        <!-- 预计举办日期 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.activityInfo.edoh')" prop="expectStartDate">
            <el-date-picker value-format="yyyy-MM-dd HH:mm:ss"
                            :disabled="isReadOnly && !isFilterFields('expectStartDate')" type="datetime"
                            @change="expectStartDateChange" :placeholder="$t('general.psad')" v-model="formData.expectStartDate"
                            :picker-options="pickerOptions" style="width: 100%;"
            />
          </el-form-item>
        </el-col>
        <!-- 转申请可以编辑预计结束日期 -->
        <!-- 预计结束日期 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.activityInfo.eed')" prop="expectEndDate">
            <el-date-picker value-format="yyyy-MM-dd HH:mm:ss"
                            :disabled="isReadOnly && !isFilterFields('expectEndDate')" type="datetime"
                            :placeholder="$t('general.psad')" v-model="formData.expectEndDate" :picker-options="pickerOptions"
                            style="width: 100%;"
            />
          </el-form-item>
        </el-col>
        <!-- 活动场地查看 -->
        <el-col v-if="lang === 'zh-CN' && !$store.state.useSimplifiedForm" :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.activityInfo.hdcdtj')">
            <div class="active-text" @click="goToLook">
              {{ $t('general.ctView') }}
            </div>
          </el-form-item>
        </el-col>
        <!-- 活动基地 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityBaseList.length">
          <el-form-item :label="$t('newApp.activityInfo.hdjd')" prop="activityBaseName">
            <el-select
              v-model="formData.activityBaseName"
              :disabled="isReadOnly"
              placeholder="请选择"
              @change="activityBaseNameChange"
              @focus="activityFileCommand"
            >
              <el-option v-for="item in activityBaseList" :key="item.id" :label="item.name" :value="item.name">
                <el-popover placement="right-end" width="300" trigger="hover" :disabled="item.name === '不使用'">
                  <div style="margin: 0;width:100%;">
                    <img :src="item.file" style="width:100%;height:auto">
                  </div>
                  <div slot="reference">{{ item.name }}</div>
                </el-popover>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 基地联系方式 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8"
                v-if="formData.activityBaseName && formData.activityBaseName !== '不使用' && activityBaseList.length"
        >
          <el-form-item :label="$t('newApp.activityInfo.jdlx')" prop="activityBaseContactInformation">
            <el-input v-model="formData.activityBaseContactInformation" maxlength="50" readonly />
          </el-form-item>
        </el-col>
        <!-- 联合市场活动 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8"
                v-if="(isReadOnly && formData.isUnionMarket) || salerData.belongToSmb"
        >
          <el-form-item :label="$t('newApp.activityInfo.jma')">
            <el-radio-group v-model="formData.isUnionMarket" :disabled="isReadOnly" @change="isUnionMarketChange"
                            v-if="!isReadOnly"
            >
              <el-radio :label="1">{{ $t('general.yes') }}</el-radio>
              <el-radio :label="0" :disabled="smbStatus">{{ $t('general.no') }}</el-radio>
            </el-radio-group>
            <div class="custom" v-else>
              {{ formData.isUnionMarket ? `${$t('general.yes')}` : `${$t('general.no')}` }}
            </div>
          </el-form-item>
        </el-col>
        <!-- 国际渠道 -->
        <el-col v-if="formData.isUnionMarket === 1 && salerData.belongToSmb" :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.activityInfo.ic')">
            <el-radio-group v-model="formData.isInternationalQd" :disabled="isReadOnly"
                            @change="isInternationalQdChange"
            >
              <el-radio :label="1">{{ $t('general.yes') }}</el-radio>
              <el-radio :label="0">{{ $t('general.no') }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <!-- 渠道签约类型 -->
        <el-col v-if="formData.isUnionMarket === 1 && salerData.belongToSmb" :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.activityInfo.cst')" prop="unionChannelType"
                        :required="formData.isUnionMarket === 1 && salerData.belongToSmb"
          >
            <el-select v-model="formData.unionChannelType" :disabled="isReadOnly" :placeholder="$t('general.ps')"
                       @change="unionChannelTypeChange"
            >
              <el-option v-for="(item, index) in unionChannelTypeList" :key="index" :label="item.name"
                         :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 渠道名称 -->
        <el-col v-if="formData.isUnionMarket === 1 && salerData.belongToSmb" :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.activityInfo.cn')" prop="unionChannelName"
                        :required="formData.isUnionMarket === 1 && salerData.belongToSmb"
          >
            <el-select :disabled="isReadOnly" v-model="formData.unionChannelName" filterable remote reserve-keyword
                       :placeholder="$t('general.peak')" :remote-method="unionChannelRemote" :loading="unionChannelLoading"
            >
              <el-option v-for="(item, index) in unionChannelNameList" :key="index" :label="item.companyName"
                         company-name :value="item.companyName"
              />
            </el-select>
          </el-form-item>
        </el-col>

        <!-- 活动分层 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="!belongToSbg && lang === 'zh-CN' && !$store.state.useSimplifiedForm">
          <el-form-item :label="$t('newApp.activityInfo.csl')" prop="activityLevel"
                        :required="!belongToSbg && lang === 'zh-CN'"
          >
            <el-select v-model="formData.activityLevel" :disabled="isReadOnly || lang === 'zh-CN'" reserve-keyword
                       :placeholder="$t('general.ps')"
            >
              <el-option v-for="item in activityLevelList" :key="item.fieldKey" :label="item.fieldValue"
                         :value="item.fieldKey"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 高层/关键客户活动（简化UI用户专用） -->
        <el-col v-if="$store.state.useSimplifiedForm" :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.activityInfo.skca')" prop="seniorKeyCustomerActivity"
                        :rules="[{ required: $store.state.useSimplifiedForm, message: $t('newApp.activityInfo.skcaP'), trigger: 'change' }]">
            <el-radio-group v-model="formData.seniorKeyCustomerActivity"
                            :disabled="isReadOnly && !isFilterFields('seniorKeyCustomerActivity')">
              <el-radio label="1">{{ $t('general.yes') }}</el-radio>
              <el-radio label="0">{{ $t('general.no') }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <!-- 是否需要活动组支持 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="needOrganizerShow">
          <el-form-item :label="$t('newApp.activityInfo.dynags')">
            <el-radio-group v-model="formData.needOrganizer" @change="needOrganizerChange" :disabled="isReadOnly"
                            v-if="!isReadOnly"
            >
              <el-radio :label="1">{{ $t('general.yes') }}</el-radio>
              <el-radio :label="0">{{ $t('general.no') }}</el-radio>
            </el-radio-group>
            <div class="custom" v-else>
              {{ formData.needOrganizer ? `${$t('general.yes')}` : `${$t('general.no')}` }}
            </div>
          </el-form-item>
        </el-col>
        <!-- 预算金额 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8"
                v-if="needOrganizerShow && this.formData.needOrganizer === 1"
        >
          <el-form-item :label="$t('newApp.activityInfo.ba')" prop="budgetAmount">
            <el-input v-model="formData.budgetAmount" @input="budgetAmountChange" :disabled="isReadOnly"
                      maxlength="8"
            />
          </el-form-item>
        </el-col>
        <!-- 注：线上总部活动需提前15天报备申请，线下活动需提前一个月报备申请，您未按时申请，请填写理由 -->
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24"
                v-if="needOrganizerShow && organizerReasonShow && this.formData.needOrganizer === 1"
        >
          <el-form-item prop="organizerReason" :label="$t('newApp.activityInfo.desc')" class="folding">
            <el-input type="textarea" v-model="formData.organizerReason" :disabled="isReadOnly" maxlength="1000"
                      show-word-limit
            />
          </el-form-item>
        </el-col>
        <!-- 是否年度规划线上活动  -->
        <!-- 仅当 ifcomplianceDocuments 判定为 true 时显示；否则自动清空 isCompliance -->
        <el-col v-if="ifcomplianceDocuments" :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item :label="$t('newApp.activityInfo.sfndghxshd')" prop="isCompliance">
            <div>
              <el-radio-group v-model="formData.isCompliance">
                <el-radio :label="1">{{ $t('general.yes') }}</el-radio>
                <el-radio :label="0">{{ $t('general.no') }}</el-radio>
              </el-radio-group>
            </div>
          </el-form-item>
        </el-col>
        <!-- 新字段 -->
        <!-- 关键举措 -->
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="!$store.state.useSimplifiedForm">
          <el-form-item :label="$t('newApp.activityInfo.ki')" class="multistage">
            <el-row>
              <el-col
                :span="24" class="cruxCustomStyle"
                :class="formData.cruxCheckbox.length > 0 ? 'borderStyle' : ''"
                v-if="!isReadOnly || isFilterFields('cruxCheckbox')"
              >
                <div>
                  <el-checkbox-group
                    v-model="formData.cruxCheckbox"
                    @change="cruxCheckboxChange"
                  >
                    <!-- <template v-if="lang!=='zh-CN' || (lang === 'zh-CN' && formData.activityClassificationCode !== 'AC_06')">
                    </template> -->
                    <template v-for="item in cruxCheckboxList">
                      <el-checkbox :key="item.key" :label="item.key" name="cruxCheckbox" v-if="item.disabled()">
                        {{ $t(`newApp.activityInfo.${item.value}`) }}
                      </el-checkbox>
                    </template>
                  </el-checkbox-group>
                </div>
              </el-col>
              <el-col :span="12" v-if="formData.cruxCheckbox.indexOf('remotePoc') > -1">
                <el-form-item :label="$t('newApp.activityInfo.rpn')" prop="remotePoc">
                  <el-input v-model="formData.remotePoc" maxlength="150" :disabled="isReadOnly && !isFilterFields('remotePoc')" />
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="formData.cruxCheckbox.indexOf('unitedDiamondActivity') > -1">
                <el-form-item :label="$t('newApp.activityInfo.nofd')" prop="unitedDiamondActivity">
                  <el-input v-model="formData.unitedDiamondActivity" maxlength="150" :disabled="isReadOnly && !isFilterFields('unitedDiamondActivity')" />
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="formData.cruxCheckbox.indexOf('circleActivity') > -1">
                <el-form-item :label="$t('newApp.activityInfo.noc')" prop="circleActivity">
                  <el-input v-model="formData.circleActivity" maxlength="150" :disabled="isReadOnly && !isFilterFields('circleActivity')" />
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="formData.cruxCheckbox.indexOf('templateVisit') > -1">
                <el-form-item :label="$t('newApp.activityInfo.tn')" prop="templateVisit">
                  <el-input v-model="formData.templateVisit" maxlength="150" :disabled="isReadOnly && !isFilterFields('templateVisit')" />
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="formData.cruxCheckbox.indexOf('machineDemo') > -1">
                <el-form-item :label="$t('newApp.activityInfo.machineDemo')" prop="machineDemo">
                  <el-input v-model="formData.machineDemo" maxlength="150" :disabled="isReadOnly && !isFilterFields('machineDemo')" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>
        <!-- 活动预计包含板块 -->
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24"
                v-if="(!salerData.belongToSmb || (formData.plateView && formData.plateView.length > 0)) && (lang !== 'zh-CN' || (lang === 'zh-CN' && formData.activityClassificationCode === 'AC_06'))"
        >
          <el-form-item :label="$t('newApp.activityInfo.teietcs')" class="folding" prop="plateView">
            <template v-if="!isReadOnly || isActivityFields('plateView')">
              <el-checkbox-group
                v-model="formData.plateView"
                @change="plateOtherChange"
                :disabled="isReadOnly && !isActivityFields('plateView')"
              >
                <el-checkbox v-for="item in plateList" :key="item.fieldKey" :label="item.fieldKey" name="plateType">
                  {{
                    item.fieldValue
                  }}
                </el-checkbox>
              </el-checkbox-group>
              <div v-if="plateOtherShow">
                <el-input type="textarea" v-model="formData.plateOther" :disabled="isReadOnly && !isActivityFields('plateView')" maxlength="50" />
              </div>
            </template>
            <div class="custom">{{ formData.mactModuleView }}</div>
          </el-form-item>
        </el-col>
        <!-- 活动内容涉及产品线 -->
        <el-col v-if="formData.needOrganizer !== 1" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <ProductLineSelect
            ref="productLineSelectRef"
            v-model="formData.productlineSupplement"
            :productline-supplement-list="productlineSupplementList"
            :disabled="isReadOnly && !isFilterFields('productlineSupplement')"
            :read-only="isReadOnly && !isFilterFields('productlineSupplement')"
            :read-only-text="formData.productlineView"
            :show-other-input="true"
            :productline-other.sync="formData.productlineOther"
            :activity-code="formData.activityCode"
            :report-type="1"
          />
        </el-col>
        <!-- 战略产品 - 交流场景 -->
        <el-col v-if="salerData.belongToQyw && lang === 'zh-CN'" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <el-form-item :label="comscValue" class="folding" prop="communicationScenarioList">
            <template>
              <el-checkbox-group
                v-model="formData.communicationScenarioList"
                @change="productlineSupplementChange($event)"
              >
                <el-checkbox
                  v-for="item in fbCommunicationScenario"
                  :key="item.fieldKey"
                  :label="item.fieldValue"
                  name="productlineSupplementType"
                >
                  {{ item.fieldValue }}
                </el-checkbox>
              </el-checkbox-group>
              <!-- <div v-if="productlineOtherShow">
                <el-input type="textarea" v-model="formData.productlineOther" :disabled="isReadOnly" maxlength="50" />
              </div>-->
            </template>
            <!-- <div class="custom">{{ formData.productlineView }}</div> -->
          </el-form-item>
        </el-col>
        <!-- 活动议程 -->
        <el-col v-if="agendaList.length" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <el-form-item :label="$t('newApp.activityInfo.agenda')" class="folding" prop="agendaShow">
            <template>
              <el-checkbox-group v-model="formData.agendaShow" @change="agendaListChange($event)">
                <el-checkbox v-for="item in agendaList" :key="item.fieldKey" :label="item.agenda"
                             name="productlineSupplementType"
                >
                  {{ item.agenda }}
                </el-checkbox>
              </el-checkbox-group>
            </template>
          </el-form-item>
        </el-col>
        <!-- 活动背景&目的 -->
        <el-col v-if="lang === 'zh-CN'" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <el-form-item :label="$t('newApp.activityInfo.ActivityBgA')" class="folding" prop="activityBackgroundPurpose">
            <template>
              <el-input type="textarea" v-model.trim="formData.activityBackgroundPurpose" :disabled="isReadOnly && !isFilterFields('activityBackgroundPurpose')"
                        :placeholder="$store.state.useSimplifiedForm ? '请填写客户与锐捷双方希望达成的目的' : '需填写活动目的，背景，会议目标，会议议程'" maxlength="1000" show-word-limit
              />
            </template>
          </el-form-item>
        </el-col>
        <!-- 活动目标（简化UI用户专用） -->
        <el-col v-if="$store.state.useSimplifiedForm" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <el-form-item :label="$t('newApp.activityInfo.hdmb')" class="folding" prop="activityTarget">
            <el-input type="textarea" v-model.trim="formData.activityTarget"
                      :disabled="isReadOnly && !isFilterFields('activityTarget')"
                      :placeholder="$t('newApp.activityInfo.hdmbP')" maxlength="500" show-word-limit />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import axios from 'axios';
import { newApplicationFormApi } from '../../service';
import { activityBaseApi } from '@/views/backStageManagement/service';
import { mapState } from 'vuex';
import { arrayQuery, isNotEmpty } from '@/utils/utils';
import { bus } from '@/utils/bus';
import targetObjectMixin from '../../mixins/targetObjectMixin';
import ProductLineSelect from './ProductLineSelect.vue';
const CLASSIFICATION_WHITELIST = new Set(['AC_06', 'AC_02', 'AC_01']);
const ONLINE_FORMS = new Set(['线上活动', '1+N（线上线下结合）', 'Online Event']);
const DEPT_PREFIX = '000013';
export default {
  mixins: [targetObjectMixin],
  components: {
    ProductLineSelect
  },
  data () {
    let unionChannelTypeMessage = (rule, value, callback) => {
      if (!value && this.formData.isUnionMarket === 1 && this.salerData.belongToSmb) {
        callback(new Error(`${this.$t('newApp.activityInfo.pscst')}`));
      } else {
        callback();
      }
    };
    let unionChannelNameMessage = (rule, value, callback) => {
      if (!value && this.formData.isUnionMarket === 1 && this.salerData.belongToSmb) {
        callback(new Error(`${this.$t('newApp.activityInfo.psacn')}`));
      } else {
        callback();
      }
    };
    let businessUnitMessage = (rule, value, callback) => {
      if (value.length < 1 && this.salerData.belongToQyw && this.unitNameList.length > 0) {
        callback(new Error(`${this.$t('newApp.activityInfo.psabu')}`));
      } else {
        callback();
      }
    };
    let relatedActivityCodeMessage = (rule, value, callback) => {
      if (!value && this.relationActivityRequired) {
        callback(new Error(`${this.$t('newApp.activityInfo.pstaacn')}`));
      } else {
        callback();
      }
    };
    let startDateValidator = (rule, value, callback) => {
      if (this.formData.expectStartDate > this.formData.expectEndDate) {
        callback(new Error(`${this.$t('newApp.activityInfo.tsdcbgtted')}`));
      } else {
        if (value) {
          callback();
        } else {
          callback(new Error(`${this.$t('newApp.activityInfo.psasd')}`));
        }
      }
    };
    let endDateValidator = (rule, value, callback) => {
      if (this.formData.expectStartDate > this.formData.expectEndDate) {
        callback(new Error(`${this.$t('newApp.activityInfo.tsdcbgtted')}`));
      } else {
        if (value) {
          callback();
        } else {
          callback(new Error(`${this.$t('newApp.activityInfo.psaed')}`));
        }
      }
    };
    let productlineValidator = (rule, value, callback) => {
      this.$nextTick(() => {
        const ref = this.$refs.productLineSelectRef;
        if (ref && ref.internalOtherShow && !this.formData.productlineOther) {
          callback(new Error(`${this.$t('newApp.activityInfo.pepl')}`));
        } else {
          callback();
        }
      });
    };
    let plateValidator = (rule, value, callback) => {
      this.$nextTick(() => {
        if (this.plateOtherShow && !this.formData.plateOther) {
          callback(new Error(`${this.$t('newApp.activityInfo.peteis')}`));
        } else {
          callback();
        }
      });
    };
    return {
      rules: {
        budgetAmount: [
          { required: true, message: `${this.$t('newApp.activityInfo.peba')}`, trigger: 'blur' }
        ],
        organizerReason: [
          { required: true, message: `${this.$t('newApp.activityInfo.petrfa')}`, trigger: 'blur' }
        ],
        businessUnitDisplayed: [
          { validator: businessUnitMessage, trigger: 'change' }
        ],
        isCompliance: [
          { required: true, message: `${this.$t('newApp.activityInfo.sfndghxshdTSY')}`, trigger: 'change' }
        ],
        activityName: [
          { required: true, message: `${this.$t('newApp.activityInfo.peen')}`, trigger: 'blur' }
        ],
        activityClassificationCode: [
          { required: true, message: `${this.$t('newApp.activityInfo.psaac')}`, trigger: 'change' }
        ],
        targetObject: [
          { required: true, message: `${this.$t('newApp.activityInfo.pstmt')}`, trigger: 'change' }
        ],
        organizer: [
          { required: true, message: `${this.$t('newApp.activityInfo.psao')}`, trigger: 'change' }
        ],
        city: [
          { required: true, message: `${this.$t('newApp.activityInfo.pehc')}`, trigger: 'blur' }
        ],
        activityTypeCode: [
          { required: true, message: `${this.$t('newApp.activityInfo.psaet')}`, trigger: ['change', 'blur'] }
        ],
        qdMeetingSegment: [
          { required: true, message: `${this.$t('newApp.activityInfo.psacms')}`, trigger: 'change' }
        ],
        activityBaseName: [
          { required: true, message: `${this.$t('newApp.activityInfo.pshdjd')}`, trigger: 'change' }
        ],
        activityBaseContactInformation: [
          { required: true, message: `${this.$t('newApp.activityInfo.psjdlx')}`, trigger: 'blur' }
        ],
        activityForms: [
          { required: true, message: `${this.$t('newApp.activityInfo.psaef')}`, trigger: 'change' }
        ],
        unionChannelType: [
          { validator: unionChannelTypeMessage, trigger: 'change' }
        ],
        unionChannelName: [
          { validator: unionChannelNameMessage, trigger: 'change' }
        ],
        inviterNum: [
          { required: true, message: `${this.$t('newApp.activityInfo.pettnop')}`, trigger: 'blur' }
        ],
        expectStartDate: [
          { required: true, message: `${this.$t('newApp.activityInfo.psasd')}`, trigger: 'change' },
          { validator: startDateValidator, trigger: 'change' }
        ],
        expectEndDate: [
          { required: true, message: `${this.$t('newApp.activityInfo.psaed')}`, trigger: 'change' },
          { validator: endDateValidator, trigger: 'change' }
        ],
        relatedActivityCode: [
          { validator: relatedActivityCodeMessage, trigger: 'change' }
        ],
        plateView: [
          { required: true, message: `${this.$t('newApp.activityInfo.teietcs')}`, trigger: 'change' },
          { validator: plateValidator, trigger: 'change' }
        ],
        productlineSupplement: [
          { required: true, message: `${this.$t('newApp.activityInfo.psapl')}`, trigger: 'change' },
          { validator: productlineValidator, trigger: 'change' }
        ],
        communicationScenarioList: [
          { required: true, message: `${this.$t('newApp.activityInfo.Psstrpr')}`, trigger: 'change' }
        ],
        agendaShow: [
          { required: true, message: `${this.$t('newApp.activityInfo.Psagenda')}`, trigger: 'change' }
        ],
        remotePoc: [
          { required: true, message: `${this.$t('newApp.activityInfo.perp')}`, trigger: 'blur' }
        ],
        unitedDiamondActivity: [
          { required: true, message: `${this.$t('newApp.activityInfo.pejda')}`, trigger: 'blur' }
        ],
        circleActivity: [
          { required: true, message: `${this.$t('newApp.activityInfo.peca')}`, trigger: 'blur' }
        ],
        templateVisit: [
          { required: true, message: `${this.$t('newApp.activityInfo.peastv')}`, trigger: 'blur' }
        ],
        machineDemo: [
          { required: true, message: `${this.$t('newApp.activityInfo.psMachineDemo')}`, trigger: 'blur' }
        ],
        activityBackgroundPurpose: [
          { required: this.$route.path === '/activityTransferApplication', message: '请输入活动背景&目的', trigger: ['blur', 'change'] }
        ],
        seniorKeyCustomerActivity: [
          { required: this.$store.state.useSimplifiedForm, message: this.$t('newApp.activityInfo.skcaP'), trigger: 'change' }
        ]
      },
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      targetObjectList: [], // 主要目标对象列表
      brandPromotionSupporList: [], // 品推支持
      organizerList: [], // 主办方列表
      activityClassificationList: [], // 活动分类
      activityFormsList: [], // 活动形式
      productlineSupplementList: [], // 活动内容涉及产品线
      relationActivityList: [], // 关联活动分类列表
      activityTypeList: [], // 活动类型列表
      activityLevelList: [], // 活动分层列表
      qdMeetingSegmentList: [], // 渠道会议细分列表
      unionChannelTypeList: [], // 签约渠道类型列表
      unionChannelNameList: [], // 渠道名称列表,
      unitNameList: [], // 业务单元列表
      plateList: [], // 活动预计包含板块列表
      comscValue: '',
      fbCommunicationScenario: [], // 交流场景列表
      fbCommunicationScenarioOld: [], // 原交流场景列表
      fbCommunicationScenarioNew: [], // 战略产品列表
      agendaList: [], // 活动议程列表
      sourceLink: '',
      formData: {
        cruxCheckbox: [],
        plateView: [],
        productlineSupplement: [],
        businessUnitDisplayed: [],
        communicationScenarioList: [],
        mactCommunicationScenarioList: [],
        mactAgendaList: [],
        agendaShow: [],
        activityBackgroundPurpose: '',
        activityTarget: '',
        seniorKeyCustomerActivity: '',
        isUnionMarket: 0,
        isInternationalQd: 0,
        needOrganizer: 0,
        isBatchApprove: null,
        isCompliance: ''
      },
      plateOtherShow: false, // 活动预计包含板块'其他'显隐
      relationActivityName: '关联活动名称:',
      relationActivityShow: false, // 关联活动是否显示
      relationActivityRequired: false, // 关联活动是否必填
      needOrganizerShow: false, // 是否需要活动组支持显隐
      organizerReasonShow: false, // 需要活动组理由显隐
      isReadOnly: false, // 只读模式
      unionChannelLoading: false, // 渠道名称loading
      brandPromotionSupportShow: true, // 品推支持显隐
      agendaStatus: false, // 活动议程显隐
      isEditable: 0,
      cruxCheckboxList: [
        {
          key: 'remotePoc',
          name: '远程POC',
          value: 'rp',
          disabled: () => {
            return this.lang !== 'zh-CN' || (this.lang === 'zh-CN' && this.formData.activityClassificationCode === 'AC_06');
          }
        },
        {
          key: 'unitedDiamondActivity',
          name: '联合精钻活动',
          value: 'jra',
          disabled: () => {
            return this.lang !== 'zh-CN' || (this.lang === 'zh-CN' && this.formData.activityClassificationCode === 'AC_06');
          }
        },
        {
          key: 'circleActivity',
          name: '圈子活动',
          value: 'ca',
          disabled: () => {
            return true;
          }
        },
        {
          key: 'templateVisit',
          name: '样板参观',
          value: 'mv',
          disabled: () => {
            return true;
          }
        },
        {
          key: 'machineDemo',
          name: '样机演示/体验',
          value: 'machineDemo',
          disabled: () => {
            return true;
          }
        }
      ],
      activityBaseList: [],
      lang: localStorage.getItem('lang') || 'zh-CN',
      belongToSbg: false, // 是否是sbg部门
      smbStatus: false,
      salerDeptCode: []
    };
  },
  props: {
    editEchoData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    setCacheList: {
      type: Function,
      default: () => {
        return {};
      }
    },
    updateForm: {
      type: Function,
      default: () => {
        return {};
      }
    },
    inviterNum: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      salerData: (state) => state.newApplication.salerData
    }),
    // 当前路由时(报备)部分字段可以修改
    isFilterFields () {
      const editFields = [
        'relatedActivityCode',
        'expectStartDate',
        'expectEndDate',
        'cruxCheckbox',
        'productlineSupplement',
        'communicationScenarioList',
        'activityBackgroundPurpose',
        'activityTarget',
        'seniorKeyCustomerActivity',
        'qdMeetingSegment',
        'remotePoc',
        'unitedDiamondActivity',
        'circleActivity',
        'templateVisit',
        'machineDemo'
      ];
      const pathList = ['/transferApplication', '/activityTransferApplication', '/quickTransferApplication'];
      if (this.editEchoData && this.editEchoData.marketActivity && this.editEchoData.marketActivity.reportType) {
        editFields.push('activityTypeCode');
      }
      return (fieldCode) => {
        return pathList.includes(this.$route.path) && editFields.includes(fieldCode);
      };
    },
    // 报备转申请需要补充的部分字段
    isActivityFields () {
      const activityFields = ['plateView'];
      return (fieldCode) => {
        return activityFields.includes(fieldCode);
      };
    },
    ifcomplianceDocuments () {
      // 活动分类 - activityClassificationCode
      // 活动形式 - activityForms
      const { activityClassificationCode, activityForms } = this.formData;
      if (!activityClassificationCode || !activityForms) return false;
      const deptCode = (this.$store.state.userInfo?.sysUser?.deptCode || '').trim();
      return CLASSIFICATION_WHITELIST.has(activityClassificationCode) &&
             ONLINE_FORMS.has(activityForms) &&
             deptCode.startsWith(DEPT_PREFIX);
   }
  },
  watch: {
    salerData: {
      immediate: true,
      deep: true,
      handler (data) {
        if (isNotEmpty(data.deptCode)) {
          this.salerDeptCode = data.deptCode;
          this.getActivityBaseList(data.deptCode);
          this.getActivityList(data.deptCode);
          this.getActivityTypeList('全部', data.deptCode);
          if (data.deptCode.startsWith('000063')) {
            this.belongToSbg = true;
            // this.$set(this.formData, 'activityLevel', '');
          } else {
            this.belongToSbg = false;
            if (!this.formData.activityLevel) {
              // this.$set(this.formData, 'activityLevel', 'B');
            }
          }
        }
        if (this.$store.state.newApplication.salerLoadFlag) return;
        // 清空业务单元
        this.formData.businessUnitDisplayed = [];
        this.unitNameList = [];
        this.$nextTick(() => {
          this.$refs.activityInfoForm.clearValidate(['businessUnitDisplayed']);
        });
        this.getUnitNameList(data.deptCode);
      }
    },
    // 当合规判定条件不满足时自动清空 isCompliance
    ifcomplianceDocuments (newVal) {
      if (!newVal) this.formData.isCompliance = '';
    },
    'formData.isCompliance' (newVal) {
      this.$parent.complianceComponent(newVal);
    },
    editEchoData: {
      immediate: true,
      deep: true,
      handler (newVal) {
        if (isNotEmpty(newVal) && isNotEmpty(newVal.mactExpenseBelongVOList)) {
          this.smbStatus = newVal.mactExpenseBelongVOList.some(item => item.mactExpenseBelong.expenseTypeCode === 'EI172');
          this.$set(this.formData, 'isUnionMarket', this.smbStatus ? 1 : this.formData.isUnionMarket);
          this.$store.commit('newApplication/setIsUnionMarket', 1);
        } else {
          this.smbStatus = false;
          this.$store.commit('newApplication/setIsUnionMarket', 0);
        }
      }
    },
    formData: {
      immediate: true,
      deep: true,
      handler (newVal) {
        this.updateForm(newVal);
      }
    }
  },
  created () {
    bus.$on('activeType', (list) => {
      if (isNotEmpty(list)) {
        this.smbStatus = list.some(item => item.expenseTypeCode === 'EI172');
        this.$set(this.formData, 'isUnionMarket', this.smbStatus ? 1 : this.formData.isUnionMarket);
        this.$store.commit('newApplication/setIsUnionMarket', 1);
      } else {
        this.smbStatus = false;
        this.$store.commit('newApplication/setIsUnionMarket', 0);
      }
    });
  },
  destroyed () {
    // 组件销毁前需要解绑事件。否则会出现重复触发事件的问题
    bus.$off('activeType');
  },
  methods: {
    isSupplementEditable (fieldKey) {
      return Boolean(this.interfaceFields && this.interfaceFields.some(item => item.key === fieldKey));
    },
    goToLook () {
      window.open('https://ruijie.feishu.cn/share/base/query/shrcnLYaqtH3GcUGNq84cJclTTd');
    },
    getActivityBaseList (deptCode) {
      const params = {
        deptCode
      };
      activityBaseApi.getConfigActivityBaseList(params).then(res => {
        if (res.status === '200') {
          if (isNotEmpty(res.data)) {
            this.activityBaseList = [{ name: '不使用', id: 'nonUseId' }, ...res.data];
            if (!this.$route.query.activityCode || (this.$route.query.activityCode && !this.formData.activityBaseName)) {
              this.$set(this.formData, 'activityBaseName', '不使用');
            }
          } else {
            this.activityBaseList = [];
          }
        }
      });
    },
    activityFileCommand () {
      this.activityBaseList.forEach(item => {
        if (item.imageUrl) {
          newApplicationFormApi.getFileToken().then(res => {
            if (res.status === '200') {
              const Token = res.data;
              this.$set(item, 'file', `${window._env_.VUE_APP_FILEOPEN_URL}/${item.imageUrl}?Token=${Token}`);
            }
          });
        }
      });
    },
    activityBaseNameChange (e) {
      const currentData = this.activityBaseList.find(item => item.name === e);
      this.$set(this.formData, 'activityBaseContactInformation', currentData.contactInformation);
      this.$set(this.formData, 'activityBaseUrl', currentData.imageUrl);
      this.$set(this.formData, 'activityBaseDeptCode', currentData.deptCode);
    },
    organizerChange (val) {
      this.$set(this.formData, 'activityTypeCode', '');
      this.formData.activityType = '';
      this.activityTypeList = [];
      this.$nextTick(() => {
        this.$refs.activityInfoForm.clearValidate(['activityTypeCode']);
      });
      // let params = this.$t('newApp.activityInfo.ht');
      let params = '主办型';
      if (val === this.$t('newApp.activityInfo.atomc')) {
        // params = this.$t('newApp.activityInfo.pt');
        params = '参与型';
      }
      this.getActivityTypeList(params, this.salerDeptCode);
    },
    getActivityTypeList (params, deptCode) {
      if (params != '参与型' && (deptCode.startsWith('000063650007') || deptCode.startsWith('000063657'))) {
        let params = ['smb_international_activity_type'];
        newApplicationFormApi.getActivityList(params).then(res => {
          if (res.status === '200') {
            let { data } = res;
            this.activityTypeList = data.smb_international_activity_type;
          }
        });
      } else {
        newApplicationFormApi.getActivityTypeList(params).then(res => {
          if (res.status === '200') {
            this.activityTypeList = res.data;
          }
        });
      }
    },
    cruxCheckboxChange () {
      // 如果取消选中项，则清空对应的输入框
      this.cruxCheckboxList.forEach(item => {
        if (this.formData.cruxCheckbox.indexOf(item.key) < 0) {
          this.$set(this.formData, item.key, '');
        }
      });
    },
    brandPromotionSupportChange (val) {
      let obj = arrayQuery(val, this.brandPromotionSupporList, 'fieldValue');
      this.formData.brandPromotionSupportKey = obj.fieldKey;
    },
    validateHandler () {
      return new Promise((resolve, reject) => {
        this.$refs['activityInfoForm'].validate((valid) => {
          if (valid) {
            resolve(true);
          } else {
            resolve(false);
          }
        });
      });
    },
    activityTypeChange (val) {
      // 获取活动类型名称
      this.formData.activityType = arrayQuery(val, this.activityTypeList, 'fieldKey').fieldValue;
      // 清除相关联字段
      this.qdMeetingSegmentClear();
    },
    relatedActivityChange (val) {
      let obj = arrayQuery(val, this.relationActivityList, 'code');
      this.formData.relatedActivityName = obj.text;
      this.formData.isBatchApprove = obj.isBatchApprove;
      this.formData.sourceLink = obj.sourceLink;
      if (this.relationActivityName === this.$t('home.ha') && isNotEmpty(obj)) {
        this.$set(this.formData, 'hqAcitvityCode', obj.code);
        this.$set(this.formData, 'hqActivityName', obj.text);
      } else {
        this.$set(this.formData, 'hqActivityCode', '');
        this.$set(this.formData, 'hqActivityName', '');
      }
      // 区域模块活动不关联活动名称
      if (this.formData.activityClassificationCode !== 'AC_01') {
        this.$set(this.formData, 'activityName', obj.text);
        this.agendaStatus = false;
        this.$set(this.formData, 'industryReportActivityCode', ''); // 清空关联模板活动的活动编码
        this.$set(this.formData, 'activitySource', null);
      } else {
        this.agendaStatus = true;
        if (val) {
          this.getTemplateActivityAgendaCommand(val);
          const index = this.relationActivityList.findIndex(item => item.code === val);
          if (index !== -1) {
            this.$set(this.formData, 'activitySource', this.relationActivityList[index].activitySource || null);
            if (this.relationActivityList[index].activityCode) {
              this.$set(this.formData, 'industryReportActivityCode', this.relationActivityList[index].activityCode);
              console.log('找到了行业报备关联模板活动', this.formData.industryReportActivityCode);
              this.$emit('clearCostAscription');
            } else {
              if (this.formData.industryReportActivityCode) {
                this.$set(this.formData, 'industryReportActivityCode', '');
                this.$emit('clearCostAscription');
              }
            }
          }
        }
      }
      this.setIndustryReportActivityCode();
      this.setActivitySource();
    },
    downloadCommand () {
      window.open(this.sourceLink);
    },
    getTemplateActivityAgendaCommand (val) {
      const currentInfo = this.relationActivityList.find(item => item.code === val);
      this.sourceLink = currentInfo.sourceLink;
      newApplicationFormApi.getTemplateActivityAgenda(val).then(res => {
        if (res.status === '200') {
          this.agendaList = res.data;
          if (!this.$route.query.activityCode) {
            this.formData.mactAgendaList = [];
            this.formData.agendaShow = [];
            res.data.forEach(item => {
              this.formData.mactAgendaList.push({
                agendaName: item.agenda,
                agendaCode: item.orderNum
              });
              this.formData.agendaShow.push(item.agenda);
            });
          }
        }
      });
    },
    agendaListChange (e) {
      this.formData.mactAgendaList = [];
      this.agendaList.forEach(item => {
        e.forEach(ite => {
          if (item.agenda === ite) {
            const index = this.formData.mactAgendaList.findIndex(iteIndex => iteIndex.agendaName === ite);
            if (index === -1) {
              this.formData.mactAgendaList.push({
                agendaName: item.agenda,
                agendaCode: item.orderNum
              });
            }
          }
        });
      });
    },
    plateOtherChange (val) {
      this.plateOtherShow = val.some(item => {
        return item === '10';
      });
    },
    qdMeetingSegmentClear () {
      this.$set(this.formData, 'qdMeetingSegment', '');
      if (!this.isTargetObjectOther) {
        this.$set(this.formData, 'targetObjectOther', '');
      }
      this.$nextTick(() => {
        this.$refs.activityInfoForm.clearValidate(['qdMeetingSegment']);
      });
    },
    budgetAmountChange (val) {
      let newVal = val.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.');
      this.$set(this.formData, 'budgetAmount', newVal);
    },
    needOrganizerChange (val) {
      this.$set(this.formData, 'budgetAmount', null);
      this.$set(this.formData, 'organizerReason', '');
      this.$store.commit('newApplication/setNeedOrganizer', val);
    },
    unionChannelNameChange (val) {
      this.$store.commit('newApplication/setIsUnionMarket', val);
    },
    unionChannelTypeChange () {
      this.unionChannelNameList = [];
      this.$set(this.formData, 'unionChannelName', '');
      this.$nextTick(() => {
        this.$refs.activityInfoForm.clearValidate(['unionChannelName']);
      });
    },
    unionChannelRemote (query) {
      if (!this.formData.unionChannelType) {
        this.$message.error(this.$t('newApp.activityInfo.pscst'));
        return;
      }
      if (query !== '') {
        let params = {
          partnerType: this.formData.unionChannelType,
          companyName: query
        };
        this.getChannelNameList(params);
      } else {
        this.unionChannelNameList = [];
      }
    },
    inviterNumFilter (val) {
      let numVal = val.replace(/[^\d]/g, '').replace(/^0{1,}/g, '');
      this.$set(this.formData, 'inviterNum', numVal);
    },
    getRelevanceActivityList (val) {
      // 简化表单选择总部活动时，不需要获取关联活动列表
      if (this.$store.state.useSimplifiedForm && val === 'AC_06') {
        return;
      }
      let params = 'NEW';
      // 根据值获取关联活动的列表
      if (val === 'AC_03' || val === 'AC_06') {
        this.agendaStatus = false;
        // 区域参加总部活动、总部重点活动
        this.relationActivityName = this.$t('home.ha');
        this.$set(this.formData, 'relatedActivityCode', this.formData.hqActivityCode);
        this.$set(this.formData, 'relatedActivityName', this.formData.hqActivityName);
        newApplicationFormApi.getHeadquarterActivity(params).then(res => {
          this.relationActivityList = res.data.map(item => {
            return {
              code: item.id + '',
              text: item.activityName,
              isBatchApprove: item.isBatchApprove,
              activityCode: item.activityCode
            };
          });
        });
      } else if (val === 'AC_01') {
        this.agendaStatus = true;
        // 区域模板活动
        this.relationActivityName = this.$t('newApp.activityInfo.ta');
        newApplicationFormApi.getTemplateActivity(params).then(res => {
          this.relationActivityList = res.data.map(item => {
            return {
              code: item.id + '',
              text: item.templateName,
              activityType: item.activityType,
              activityTypeCode: item.activityTypeCode,
              activitySubType: item.activitySubType,
              activityGoal: item.activityGoal,
              sourceLink: item.sourceLink ? item.sourceLink : '',
              activityCode: item.activityCode,
              activitySource: item.activitySource
            };
          });
          const currentInfo = this.relationActivityList.find(item => item.code === this.formData.relatedActivityCode);
          if (isNotEmpty(currentInfo)) {
            this.sourceLink = currentInfo.sourceLink;
            this.$set(this.formData, 'industryReportActivityCode', currentInfo.activityCode);
            this.setIndustryReportActivityCode();
            this.$set(this.formData, 'activitySource', currentInfo.activitySource || null);
            this.setActivitySource();
          }
          if (this.formData.relatedActivityCode) {
            this.getTemplateActivityAgendaCommand(this.formData.relatedActivityCode);
          }
        });
      } else {
        this.agendaStatus = false;
        this.relationActivityShow = false;
      }
      // 控制是否需要活动组支持显隐
      if (val === 'AC_06') {
        this.needOrganizerShow = true;
      }
    },
    activityClassificationCodeChange (val) {
      // 获取对应的活动分类名称
      this.formData.activityClassification = arrayQuery(this.formData.activityClassificationCode, this.activityClassificationList, 'fieldKey').fieldValue;

      // 简化表单选择总部活动时，隐藏关联活动字段并清空数据
      if (this.$store.state.useSimplifiedForm && val === 'AC_06') {
        this.relationActivityShow = false;
        this.relationActivityRequired = false;
        this.$set(this.formData, 'relatedActivityCode', '');
        this.formData.relatedActivityName = '';
        this.relationActivityList = [];
      } else {
        this.relationActivityShow = true;
        if (val === 'AC_06' || val === 'AC_02') {
          // 如果选择总部活动 || 区域活动，则关联活动不必填
          this.relationActivityRequired = false;
        } else {
          this.relationActivityRequired = true;
        }
        this.$set(this.formData, 'relatedActivityCode', '');
        this.formData.relatedActivityName = '';
        this.relationActivityList = [];
      }
      this.needOrganizerShow = false;

      this.brandPromotionSupportShow = true;
      // 如果选择了总部活动,隐藏品推支持字段
      if (val === 'AC_06') {
        this.brandPromotionSupportShow = false;
        this.$set(this.formData, 'brandPromotionSupport', ''); // 主办方选项清空
        this.$nextTick(() => {
          this.$refs.activityInfoForm.clearValidate(['brandPromotionSupport']);
        });
      }

      // 如果选择区域参与总部活动
      if (val === 'AC_03') {
        this.$set(this.formData, 'organizer', ''); // 主办方选项清空
        this.$nextTick(() => {
          this.$refs.activityInfoForm.clearValidate(['organizer']);
        });
      }

      this.$set(this.formData, 'needOrganizer', 0); // 是否需要活动组支持清除
      this.needOrganizerChange(0); // 触发活动组支持change方法

      this.$nextTick(() => {
        this.$refs.activityInfoForm.clearValidate(['relatedActivityCode']);
      });

      this.$store.commit('newApplication/setActivityClassificationLoadFlag', 0);
      this.$store.commit('newApplication/setActivityClassification', val);
      if (val !== 'AC_01') {
        this.agendaList = [];
        this.formData.agendaShow = [];
        this.formData.mactAgendaList = [];
        this.$set(this.formData, 'industryReportActivityCode', ''); // 清空关联模板活动的活动编码
        this.$set(this.formData, 'activitySource', null);
      }
      this.setIndustryReportActivityCode();
      this.setActivitySource();
      this.getRelevanceActivityList(val);
      for (let i = this.cruxCheckboxList.length - 1; i >= 0; i--) {
        const item = this.cruxCheckboxList[i];
        if (this.formData.cruxCheckbox.includes(item.key)) {
          this.formData.cruxCheckbox.splice(this.formData.cruxCheckbox.indexOf(item.key), 1);
        }
      }

      this.$set(this.formData, 'plateView', []);
      this.$set(this.formData, 'cruxCheckbox', []);

      // 将数据提交到父级关联使用
      this.setCacheList('activityClassificationCode', val);
    },
    setIndustryReportActivityCode () {
      console.log('设置行业报告活动编码', this.formData.industryReportActivityCode);
      this.$emit('getIndustryReportActivityCode', this.formData.industryReportActivityCode);
    },
    setActivitySource () {
      this.$emit('getActivitySource', this.formData.activitySource);
    },
    isUnionMarketChange (val) {
      if (val === 0) {
        this.unionChannelClear();
      }
      this.unionChannelNameChange(val);
    },
    unionChannelClear () {
      this.$set(this.formData, 'unionChannelType', '');
      this.$set(this.formData, 'unionChannelName', '');
      this.unionChannelNameList = [];
      this.$nextTick(() => {
        this.$refs.activityInfoForm.clearValidate(['unionChannelType', 'unionChannelName']);
      });
    },
    isInternationalQdChange (val) {
      this.getChannelTypeList(val);
      this.unionChannelClear();
    },
    expectStartDateChange (val) {
      let future = new Date(val).getTime();
      let current = new Date().getTime();
      let fifteenDays = 15 * 24 * 60 * 60 * 1000;
      this.organizerReasonShow = future < (current + fifteenDays);
    },
    productlineSupplementChange (e) {
      const { activityCode } = this.$store.state.newApplication;
      const eventCode = this.$route.query.activityCode || activityCode;
      this.formData.mactCommunicationScenarioList = [];
      this.fbCommunicationScenario.forEach(item => {
        e.forEach(ite => {
          if (item.fieldValue === ite) {
            const index = this.formData.mactCommunicationScenarioList.findIndex(iteIndex => iteIndex.communicationScenarioName === ite);
            if (index === -1) {
              this.formData.mactCommunicationScenarioList.push({
                activityCode: eventCode,
                communicationScenarioName: item.fieldValue,
                communicationScenarioCode: item.fieldKey,
                reportType: 1
              });
            }
          }
        });
      });
    },
    productlineSupplementFilter () {
      return this.$refs.productLineSelectRef ? this.$refs.productLineSelectRef.productlineSupplementFilter() : [];
    },
    plateFilter () {
      let returnVal = [];
      for (let i = 0; i < this.formData.plateView.length; i++) {
        this.plateList.forEach(item => {
          if (item.fieldKey === this.formData.plateView[i]) {
            returnVal.push({
              moduleCode: item.fieldKey,
              moduleName: item.fieldKey === '10' ? this.formData.plateOther : item.fieldValue
            });
          }
        });
      }
      return returnVal;
    },
    getUnitNameList (code) {
      newApplicationFormApi.getUnitNameList(code).then(res => {
        if (res.status === '200') {
          this.unitNameList = res.data;
        }
      });
    },
    getActivityList (code) {
      // 主办方--organizer
      // 渠道会议细分--qd_meeting_segment
      // 目标对象--target_object
      // 预计板块--plate

      let params = [
        'plate', // 预计板块
        'qd_meeting_segment', // 渠道会议细分
        'organizer', // 主办方
        'target_object', // 目标对象
        'union_market_help',
        'activity_forms',
        'activity_classification',
        'productline_supplement',
        'expense_detail_item',
        'brand_promotion_suppor',
        'fb_communication_scenario',
        'activity_level'
      ];
      newApplicationFormApi.getActivityList(params).then(res => {
        if (res.status === '200') {
          let { data } = res;
          this.plateList = data.plate;
          this.qdMeetingSegmentList = data.qd_meeting_segment;
          this.organizerList = data.organizer;
          this.targetObjectList = data.target_object;
          this.activityFormsList = data.activity_forms;
          this.productlineSupplementList = data.productline_supplement;
          this.brandPromotionSupporList = data.brand_promotion_suppor;
          this.fbCommunicationScenarioNew = data.fbCommunicationScenario.filter(item => item.flag);
          this.fbCommunicationScenarioOld = data.fbCommunicationScenario.filter(item => !item.flag);
          if (this.$route.path !== '/editApplication') {
            this.fbCommunicationScenario = this.fbCommunicationScenarioNew;
            this.comscValue = this.$t('newApp.activityInfo.strpr');
          } else {
            const { mactCommunicationScenarioList } = this.editEchoData;
            if (isNotEmpty(mactCommunicationScenarioList)) {
              const index = this.fbCommunicationScenarioNew.findIndex(item => item.fieldKey === mactCommunicationScenarioList[0].communicationScenarioCode);
              if (index !== -1) {
                this.fbCommunicationScenario = this.fbCommunicationScenarioNew;
                this.comscValue = this.$t('newApp.activityInfo.strpr');
              } else {
                this.fbCommunicationScenario = this.fbCommunicationScenarioOld;
                this.comscValue = this.$t('newApp.activityInfo.comsc');
              }
            } else {
              this.fbCommunicationScenario = this.fbCommunicationScenarioNew;
              this.comscValue = this.$t('newApp.activityInfo.strpr');
            }
          }
          this.activityLevelList = data.activity_level;
          // 活动分类处理
          // 如果是报备则不展示总部活动
          let { path } = this.$route;
          if (path === '/reportApplication' || path === '/editReportApplication') {
            this.activityClassificationList = data.activity_classification.filter(item => {
              return item.fieldKey !== 'AC_06';
            });
          }

          // 对应销售为平台管理部时候不可以看到总部活动
          else if (code.startsWith('000062692')) {
            this.activityClassificationList = data.activity_classification.filter(item => {
              return item.fieldKey !== 'AC_06';
            });
          } else {
            this.activityClassificationList = data.activity_classification;
          }
        }
      });
    },
    getChannelTypeList (internationalFlag) {
      let params = internationalFlag ? 1 : 0;
      newApplicationFormApi.getChannelTypeList(params).then(res => {
        if (res.status === '200') {
          if (params) {
            this.unionChannelTypeList = res.data;
            return;
          }
          this.unionChannelTypeList = res.data.filter(item => {
            return item.deptType === 'smb';
          });
        }
      });
    },
    getChannelNameList (params) {
      this.unionChannelLoading = true;
      let interfaceFun = this.formData.isInternationalQd ? newApplicationFormApi.getInternationalNameList(params) : newApplicationFormApi.getChannelNameList(params);
      interfaceFun.then(res => {
        if (res.status === '200') {
          this.unionChannelNameList = res.data;
        }
        this.unionChannelLoading = false;
      });
    },
    /**
     * 修改字段
     */
    updateValue (key, val) {
      // this.formData[key] = val;
      this.$set(this.formData, key, val);
    }
  },
  mounted () {
    if (this.lang !== 'zh-CN') {
      this.cruxCheckboxList.splice(2, 1);
    };
    let userInfo = this.$store.state.userInfo;
    // 编辑处理
    if (this.$route.query.activityCode) {
      // 如果是转申请页或者报备编辑页就全部禁止操作
      const pathList = ['/transferApplication', '/editReportApplication', '/activityTransferApplication', '/quickTransferApplication'];
      if (pathList.includes(this.$route.path)) {
        this.isReadOnly = true;
      }
      // 3：表示只能编辑费用归属
      if (this.$store.state.newApplication.editFlag === 3) {
        this.isReadOnly = true;
      }
      // 编辑回显
      this.formData = {
        ...this.formData,
        ...this.editEchoData.marketActivityExpand,
        ...this.editEchoData.marketActivity
      };

      // 如果禁用了，过滤出展示信息
      if (this.isReadOnly) {
        // 活动预计板块
        if (this.editEchoData.mactModuleList && this.editEchoData.mactModuleList.length > 0) {
          this.formData.mactModuleView = this.editEchoData.mactModuleList.map(item => {
            return item.moduleName;
          }).join('，');
        }
      }
      // 活动类型处理
      let activityTypeParams = '全部';
      if (this.formData.organizer) {
        activityTypeParams = this.$t('newApp.activityInfo.ht');
        if (this.formData.organizer === this.$t('newApp.activityInfo.atomc')) {
          activityTypeParams = this.$t('newApp.activityInfo.pt');
        }
      }
      this.getActivityTypeList(activityTypeParams, this.formData.salerDeptCode);
      // 申请理由处理
      this.expectStartDateChange(this.formData.expectStartDate);
      // 获取业务单元列表
      if (this.formData.salerDeptCode) {
        this.getUnitNameList(this.formData.salerDeptCode);
      }
      // 业务单元回显处理
      if (this.formData.businessUnit && this.formData.businessUnit.length > 0) {
        this.formData.businessUnitDisplayed = this.formData.businessUnit.split(',');
      }
      // 活动分类回显处理
      if (this.formData.activityClassificationCode) {
        // 简化表单选择总部活动时，隐藏关联活动字段
        this.relationActivityShow = !(this.$store.state.useSimplifiedForm && this.formData.activityClassificationCode === 'AC_06');
        this.$store.commit('newApplication/setActivityClassificationLoadFlag', 1);
        this.$store.commit('newApplication/setActivityClassification', this.formData.activityClassificationCode);

        // 如果选择总部活动则隐藏品推支持
        if (this.formData.activityClassificationCode === 'AC_06') {
          this.brandPromotionSupportShow = false;
        }

        // 如果选择总部活动，则关联活动不必填
        if (this.formData.activityClassificationCode === 'AC_06' || this.formData.activityClassificationCode === 'AC_02') {
          this.relationActivityRequired = false;
        } else {
          this.relationActivityRequired = true;
        }
        this.getRelevanceActivityList(this.formData.activityClassificationCode);
      }
      // 联合市场活动处理
      if (this.formData.isUnionMarket) {
        this.$store.commit('newApplication/setIsUnionMarket', this.formData.isUnionMarket);
      }
      // 关键举措回显处理
      this.cruxCheckboxList.forEach(item => {
        if (this.formData[item.key]) {
          this.formData.cruxCheckbox.push(item.key);
        }
      });

      // 产品线回显处理
      if (this.editEchoData.mactProductLineList && this.editEchoData.mactProductLineList.length > 0) {
        this.$nextTick(() => {
          const result = this.$refs.productLineSelectRef.initFromEchoData(
            this.editEchoData.mactProductLineList
          );
          if (this.isReadOnly) {
            this.$set(this.formData, 'productlineView', result.productlineView);
          }
        });
      }
      // 活动预计包含板块回显处理
      if (this.editEchoData.mactModuleList && this.editEchoData.mactModuleList.length > 0) {
        this.formData.plateView = this.editEchoData.mactModuleList.map(item => {
          if (item.moduleCode === '10') {
            this.plateOtherShow = true;
            this.$set(this.formData, 'plateOther', item.moduleName);
          }
          return item.moduleCode;
        });
      }
      if (isNotEmpty(this.editEchoData.mactCommunicationScenarioList)) {
        this.formData.communicationScenarioList = this.editEchoData.mactCommunicationScenarioList.map(item => {
          return item.communicationScenarioName;
        });
        this.$set(this.formData, 'mactCommunicationScenarioList', this.editEchoData.mactCommunicationScenarioList);
      }
      if (isNotEmpty(this.editEchoData.mactAgendaList)) {
        this.formData.agendaShow = this.editEchoData.mactAgendaList.map(item => {
          return item.agendaName;
        });
        this.$set(this.formData, 'mactAgendaList', this.editEchoData.mactAgendaList);
      }
      this.$nextTick(() => {
        this.$refs.activityInfoForm.clearValidate();
      });
      this.setCacheList('activityClassificationCode', this.formData.activityClassificationCode);
    } else {
      // 新增数据初始化
      this.formData.applyUserId = userInfo.sysUser.userId;
      this.formData.applyUserName = userInfo.sysUser.userName;
      this.formData.applyUserDeptCode = userInfo.sysUser.deptCode;
      this.formData.applyUserDeptName = userInfo.sysUser.deptName;
      this.formData.applyUserType = userInfo.userType;

      this.getUnitNameList(userInfo.sysUser.deptCode);
      this.getActivityTypeList('全部', userInfo.sysUser.deptCode);
      this.getActivityList(userInfo.sysUser.deptCode); // 获取[活动分类,活动目的,活动形式,产品线]列表
    }
    this.getChannelTypeList(this.formData.isInternationalQd); // 获取渠道签约类型列表
  }
};
</script>

<style lang="scss">
.basicInformation {
  .specialRequired textarea {
    min-height: 70px !important;
  }

  .cruxCustomStyle {
    padding: 10px;

    &.borderStyle {
      border-bottom: 1px solid #dee1e7;
    }
  }
}

.active-text {
  color: #14937b;
  cursor: pointer;
}
</style>
